"use strict";
exports.__esModule = true;
/**
 * DO NOT USE VALUES IN THIS ENUM DIRECTLY. Access them via the `theme` object instead.
 */
var Colors;
(function (Colors) {
    Colors["aqua"] = "#BFEFF7";
    Colors["blueberry"] = "#5B3F8C";
    Colors["bluish"] = "#2D84CB";
    Colors["blueDark"] = "#1B4F79";
    Colors["bridalHeath"] = "#FFF8F0";
    Colors["burnt"] = "#CC8016";
    Colors["danube"] = "#667ECC";
    Colors["grass"] = "#60A66C";
    Colors["leather"] = "#997C2E";
    Colors["plum"] = "#945499";
    Colors["purpleDark"] = "#532F56";
    Colors["lilac"] = "#E1D8F1";
    Colors["whiteLilac"] = "#F7F9FC";
    Colors["redish"] = "#CC5260";
    Colors["salmon"] = "#CB7252";
    Colors["topaz"] = "#10B2A0";
    Colors["water"] = "#41A3CC";
    Colors["earth"] = "#0DAB5C";
    Colors["sun"] = "#FED325";
    Colors["fire"] = "#E61030";
    Colors["amber"] = "#FBC005";
    Colors["chestnutRose"] = "#CC5260";
    Colors["guardsmanRed"] = "#C80000";
    Colors["white"] = "#FFFFFF";
    Colors["feather"] = "#FBFBFB";
    Colors["whisper"] = "#F7F5F9";
    Colors["whisperLight"] = "#FBFAFC";
    Colors["negroni"] = "#FFE1BF";
    Colors["hummingBirdBlue"] = "#D7F5FA";
    Colors["scarpa"] = "#575766";
    Colors["silver"] = "#D9D9D9";
    Colors["coin"] = "#AAAAAA";
    Colors["boulder"] = "#767676";
    Colors["shadow"] = "#303030";
    Colors["black"] = "#000000";
    Colors["sadder"] = "#2774B3";
    Colors["sad"] = "#359DF2";
    Colors["happy"] = "#7BA660";
    Colors["happier"] = "#97CC76";
    Colors["happiest"] = "#FFC926";
    Colors["aqua1"] = "#F2FCFD";
    Colors["aqua5"] = "#5ED7EB";
    Colors["aqua6"] = "#3ABBCE";
    Colors["aqua7"] = "#008598";
    Colors["aqua8"] = "#005365";
    Colors["blue1"] = "#EBF9FF";
    Colors["blue6"] = "#009BFF";
    Colors["blue7"] = "#006AFF";
    Colors["blue8"] = "#0040FF";
    Colors["gray2"] = "#F1F0F5";
    Colors["gray3"] = "#E9E7F0";
    Colors["gray4"] = "#E3E0F5";
    Colors["gray5"] = "#C7C4D9";
    Colors["gray6"] = "#ACA9BD";
    Colors["gray7"] = "#8E8E9F";
    /**
     * @deprecated
     */
    Colors["gray8"] = "#575766";
    Colors["gray9"] = "#1B1A29";
    Colors["yellow1"] = "#FEFAEB";
    Colors["yellow3"] = "#FBE699";
    Colors["yellow4"] = "#FFDB34";
    Colors["yellow5"] = "#F4C000";
    Colors["green1"] = "#F1FCF7";
    Colors["green6"] = "#32C283";
    Colors["green7"] = "#008B51";
    Colors["green8"] = "#005723";
    Colors["indigo9"] = "#000787";
    Colors["orange1"] = "#FFF6EB";
    Colors["orange4"] = "#FFA600";
    Colors["orange5"] = "#FF8900";
    Colors["orange8"] = "#A70000";
    Colors["orange9"] = "#FFD099";
    Colors["pink1"] = "#FFF4FB";
    Colors["pink6"] = "#FF5BAE";
    Colors["pink7"] = "#EA007A";
    Colors["pink8"] = "#AB004A";
    Colors["purple1"] = "#FDF8FF";
    Colors["purple6"] = "#CE8BFF";
    Colors["purple7"] = "#9456E2";
    Colors["purple8"] = "#5B22A9";
    Colors["purple9"] = "#1B0074";
    Colors["green9"] = "#002A00";
    Colors["green5"] = "#55DE9D";
    Colors["red2"] = "#FFD6DC";
    Colors["red6"] = "#FF0037";
    // COLORSV2
    Colors["almostWhite"] = "#f7f7f8";
    Colors["jumbo"] = "#747380";
    Colors["gunpowder"] = "#3D3B4D";
    Colors["indigo"] = "#2031BD";
    Colors["mint"] = "#32C283";
    Colors["magicMint"] = "#BBF2D8";
    Colors["riverBed"] = "#4f4e5e";
    Colors["suit"] = "#bebec4";
    Colors["cornflower"] = "#6C61F7";
    Colors["buttery"] = "#FEF9E7";
    Colors["mustard"] = "#B28C00";
    Colors["rosso"] = "#CC000D";
    Colors["titanWhite"] = "#EFEEFF";
    Colors["baltic"] = "#1B1B20";
    Colors["porcelain"] = "#F1F1F2";
    Colors["persian"] = "#000787";
    Colors["deepOcean"] = "#4457F6";
    Colors["timberWolf"] = "#DBDADD";
    Colors["lightRed"] = "#FFF0F1";
    Colors["teal"] = "#10B2A0";
    Colors["dawnPink"] = "#F3EDE3";
    // DESIGN SYSTEM TOKENS
    Colors["sentimentGreen100"] = "#D0F2CF";
    Colors["sentimentGreen200"] = "#31B62F";
    Colors["sentimentGreen300"] = "#074C06";
    Colors["sentimentOrange100"] = "#F8E5C0";
    Colors["sentimentOrange200"] = "#EA9F0E";
    Colors["sentimentRed100"] = "#FFD9D9";
    Colors["sentimentRed200"] = "#C01D1D";
    Colors["sentimentRed300"] = "#910909";
    Colors["sentimentRed400"] = "#BD0E0E";
    Colors["sentimentBlue100"] = "#D4E0F3";
    Colors["yellow100"] = "#FFFEE5";
    Colors["yellow200"] = "#FFFCBD";
    Colors["yellow300"] = "#FFFB96";
    Colors["yellow400"] = "#FFFA7D";
    Colors["yellow500"] = "#FFF964";
    Colors["yellow600"] = "#E3DB29";
    Colors["yellow700"] = "#C2BA00";
    Colors["yellow800"] = "##817B08";
    Colors["yellow900"] = "#363400";
    Colors["brown100"] = "#F4E9E6";
    Colors["brown200"] = "#DCC0B7";
    Colors["brown300"] = "#BD9A8F";
    Colors["brown400"] = "#734B3F";
    Colors["brown500"] = "#391F17";
    Colors["brown600"] = "#2D150D";
    Colors["brown700"] = "#200C05";
    Colors["brown800"] = "#1D0A03";
    Colors["brown900"] = "#0D0300";
    Colors["cream100"] = "#FFF9EF";
    Colors["cream200"] = "#FDF8EE";
    Colors["cream300"] = "#FDF2DF";
    Colors["cream400"] = "#FDEDCF";
    Colors["cream500"] = "#FFE7BF";
    Colors["cream600"] = "#F1D09A";
    Colors["cream700"] = "#EFC57E";
    Colors["cream800"] = "#8D6A31";
    Colors["cream900"] = "#513912";
    Colors["fuchsia100"] = "#FDF6FF";
    Colors["fuchsia200"] = "#FBE5FF";
    Colors["fuchsia300"] = "#F8D3FF";
    Colors["fuchsia400"] = "#EFB8F9";
    Colors["fuchsia500"] = "#E39BF0";
    Colors["fuchsia600"] = "#DC7BED";
    Colors["fuchsia700"] = "#C952DE";
    Colors["fuchsia800"] = "#8D1BBD";
    Colors["fuchsia900"] = "#530262";
    Colors["lilac100"] = "#F8F2FF";
    Colors["lilac200"] = "#F4EBFF";
    Colors["lilac300"] = "#EEE0FF";
    Colors["lilac400"] = "#E5D1FF";
    Colors["lilac500"] = "#DABDFF";
    Colors["lilac600"] = "#B282F1";
    Colors["lilac700"] = "#7D2FE2";
    Colors["lilac800"] = "#5B24A5";
    Colors["lilac900"] = "#3C176C";
    Colors["pink100"] = "#FFF5FB";
    Colors["pink200"] = "#FFF0F8";
    Colors["pink300"] = "#FFE5F3";
    Colors["pink400"] = "#FFDBEF";
    Colors["pink500"] = "#FFC6E5";
    Colors["pink600"] = "#F4A5D1";
    Colors["pink700"] = "#EB7DBA";
    Colors["pink800"] = "#B84685";
    Colors["pink900"] = "#5E0033";
    Colors["sky100"] = "#F2FDFF";
    Colors["sky200"] = "#EBFBFF";
    Colors["sky300"] = "#E0F9FF";
    Colors["sky400"] = "#D3F7FF";
    Colors["sky500"] = "#BAF2FF";
    Colors["sky600"] = "#65D4EF";
    Colors["sky700"] = "#09A7CD";
    Colors["sky800"] = "#1286A4";
    Colors["sky900"] = "#03333F";
    Colors["blue100"] = "#EFF5FF";
    Colors["blue200"] = "#DCEAFF";
    Colors["blue300"] = "#B5D0FB";
    Colors["blue400"] = "#9EC5FB";
    Colors["blue500"] = "#80B2FF";
    Colors["blue600"] = "#4484E4";
    Colors["blue700"] = "#1D60C7";
    Colors["blue800"] = "#094297";
    Colors["blue900"] = "#001636";
    Colors["orange100"] = "#FFF6F0";
    Colors["orange200"] = "#FFE8D9";
    Colors["orange300"] = "#FFD3B8";
    Colors["orange400"] = "#FFC7A3";
    Colors["orange500"] = "#FFA76F";
    Colors["orange600"] = "#EF9358";
    Colors["orange700"] = "#CE7034";
    Colors["orange800"] = "#8F3D0A";
    Colors["orange900"] = "#522106";
    Colors["kiwi100"] = "#FAFFD7";
    Colors["kiwi200"] = "#EDF5B3";
    Colors["kiwi300"] = "#E1EB99";
    Colors["kiwi400"] = "#D4E26D";
    Colors["kiwi500"] = "#C0D23D";
    Colors["kiwi600"] = "#ACBD30";
    Colors["kiwi700"] = "#97AB00";
    Colors["kiwi800"] = "#6A7514";
    Colors["kiwi900"] = "#3D4501";
    Colors["lime100"] = "#F9FFF0";
    Colors["lime200"] = "#EEFFD1";
    Colors["lime300"] = "#E6FFBD";
    Colors["lime400"] = "#E1FFAD";
    Colors["lime500"] = "#CEFF78";
    Colors["lime600"] = "#9CD13C";
    Colors["lime700"] = "#74A31E";
    Colors["lime800"] = "#52711B";
    Colors["lime900"] = "#283E00";
    Colors["salmon100"] = "#FFF2F2";
    Colors["salmon200"] = "#FFEBEB";
    Colors["salmon300"] = "#FFDEDF";
    Colors["salmon400"] = "#FFCECF";
    Colors["salmon500"] = "#FF9699";
    Colors["salmon600"] = "#E56C70";
    Colors["salmon700"] = "#CF4E52";
    Colors["salmon800"] = "#B43D41";
    Colors["salmon900"] = "#810C10";
    Colors["beige100"] = "#FFF4F0";
    Colors["beige200"] = "#FFEBE5";
    Colors["beige300"] = "#FFE1D9";
    Colors["beige400"] = "#FFD7CC";
    Colors["beige500"] = "#F2C0B2";
    Colors["beige600"] = "#DE9983";
    Colors["beige700"] = "#C9775F";
    Colors["beige800"] = "#A15E49";
    Colors["beige900"] = "#65453C";
    Colors["glassDark100"] = "rgba(13,3,0,0.05)";
    Colors["glassDark200"] = "rgba(13,3,0,0.1)";
    Colors["glassDark300"] = "rgba(13,3,0,0.2)";
    Colors["glassDark400"] = "rgba(13,3,0,0.3)";
    Colors["glassDark500"] = "rgba(13,3,0,0.45)";
    Colors["glassDark600"] = "rgba(13,3,0,0.6)";
    Colors["glassDark700"] = "rgba(13,3,0,0.7)";
    Colors["glassDark800"] = "rgba(13,3,0,0.85)";
    Colors["glassDark900"] = "rgba(13,3,0,0.95)";
    Colors["neutralDark100"] = "#F2EDE3";
    Colors["neutralDark200"] = "#E6E0D7";
    Colors["neutralDark300"] = "#CCC7BF";
    Colors["neutralDark400"] = "#B3AEA7";
    Colors["neutralDark500"] = "#8C8983";
    Colors["neutralDark600"] = "#666460";
    Colors["neutralDark700"] = "#4D4B48";
    Colors["neutralDark800"] = "#262524";
    Colors["neutralDark900"] = "#0D0D0C";
    Colors["glassLight100"] = "rgba(255,249,239,0.05)";
    Colors["glassLight200"] = "rgba(255,249,239,0.1)";
    Colors["glassLight300"] = "rgba(255,249,239,0.2)";
    Colors["glassLight400"] = "rgba(255,249,239,0.3)";
    Colors["glassLight500"] = "rgba(255,249,239,0.45)";
    Colors["glassLight600"] = "rgba(255,249,239,0.6)";
    Colors["glassLight700"] = "rgba(255,249,239,0.7)";
    Colors["glassLight800"] = "rgba(255,249,239,0.85)";
    Colors["glassLight900"] = "rgba(255,249,239,0.95)";
    Colors["neutralLight100"] = "#19100D";
    Colors["neutralLight200"] = "#251C19";
    Colors["neutralLight300"] = "#3D3533";
    Colors["neutralLight400"] = "#564F4C";
    Colors["neutralLight500"] = "#7A7473";
    Colors["neutralLight600"] = "#9E9A99";
    Colors["neutralLight700"] = "#B6B3B2";
    Colors["neutralLight800"] = "#DBD9D9";
    Colors["neutralLight900"] = "#F3F2F2";
    Colors["transparent"] = "rgba(0,0,0,0)";
    /**
     * @deprecated use the more accurately named glassDark100 instead.
     */
    Colors["glass100"] = "rgba(13,3,0,0.05)";
    /**
     * @deprecated use the more accurately named glassDark200 instead.
     */
    Colors["glass200"] = "rgba(13,3,0,0.1)";
    /**
     * @deprecated use the more accurately named glassDark300 instead.
     */
    Colors["glass300"] = "rgba(13,3,0,0.2)";
    /**
     * @deprecated use the more accurately named glassDark400 instead.
     */
    Colors["glass400"] = "rgba(13,3,0,0.3)";
    /**
     * @deprecated use the more accurately named glassDark500 instead.
     */
    Colors["glass500"] = "rgba(13,3,0,0.45)";
    /**
     * @deprecated use the more accurately named glassDark600 instead.
     */
    Colors["glass600"] = "rgba(13,3,0,0.6)";
    /**
     * @deprecated use the more accurately named glassDark700 instead.
     */
    Colors["glass700"] = "rgba(13,3,0,0.7)";
    /**
     * @deprecated use the more accurately named glassDark800 instead.
     */
    Colors["glass800"] = "rgba(13,3,0,0.85)";
    /**
     * @deprecated use the more accurately named glassDark900 instead.
     */
    Colors["glass900"] = "rgba(13,3,0,0.95)";
})(Colors || (Colors = {}));
exports["default"] = Colors;
